var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2133 8C13.9467 8 14.6667 7.33334 14.0267 5.14667C13.5933 3.67334 12.3267 2.40667 10.8533 1.97334C8.66667 1.33334 8 2.05334 8 3.78667V5.70667C8 7.33334 8.66667 8 10 8H12.2133Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 9.80001C12.713 12.8867 9.75296 15.1267 6.38629 14.58C3.85963 14.1733 1.82629 12.14 1.41296 9.61334C0.872961 6.26001 3.09963 3.30001 6.17296 2.67334",
    stroke: "#1C1C1C",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overview-icon.e0cb6049e2208ef6d5ed24b02b1f3cbb.svg";
export { ForwardRef as ReactComponent };